import { configureStore } from '@reduxjs/toolkit'
import gameStateReducer from './gameState';
import playerStateReducer from './playerState';
import configStateReducer from './configState';

export default configureStore({
  reducer: {
      gameState: gameStateReducer,
      playerState: playerStateReducer,
      configState : configStateReducer
  },
  // middleware: (getDefaultMiddleware) =>
  //   getDefaultMiddleware({
  //     thunk: true,
  //     serializableCheck: false,
  //     immutableCheck: false,
  //   }),
  middleware: getDefaultMiddleware => {
    return getDefaultMiddleware({
        thunk: true,
        serializableCheck: false,
        immutableCheck: false,
        devTools: false,
      })
  },
})